#if !defined(DepthFrag_lib)
    #define DepthFrag_lib

vec4 getDepthColor()
{
    return vec4(0.0);
}

#endif // DepthFrag_lib